import { FC } from 'react'

interface IFNewsSliderArrowLeftProps {
  isShow: boolean
}

const NewsSliderArrowLeft: FC<IFNewsSliderArrowLeftProps> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="44"
      height="44"
      viewBox="0 0 44 44"
      aria-label="소식 슬라이더 왼쪽 화살표"
      display={props.isShow ? 'block' : 'none'}
    >
      <desc>소식 슬라이더 왼쪽 화살표</desc>
      <defs>
        <filter
          id="9mt3a8t7xa"
          width="44"
          height="44"
          x="0"
          y="0"
          filterUnits="userSpaceOnUse"
        >
          <feOffset dy="2"></feOffset>
          <feGaussianBlur result="blur" stdDeviation="2"></feGaussianBlur>
          <feFlood floodOpacity="0.161"></feFlood>
          <feComposite in2="blur" operator="in"></feComposite>
          <feComposite in="SourceGraphic"></feComposite>
        </filter>
      </defs>
      <g opacity="0.5">
        <g data-name="그룹 11003" filter="url(#9mt3a8t7xa)">
          <circle
            cx="16"
            cy="16"
            r="16"
            fill="#fff"
            data-name="타원 1028"
            transform="translate(6 4)"
          ></circle>
        </g>
        <path
          fill="none"
          stroke="#333"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M24.506 13.924L17.498 20l7.008 6.076"
          data-name="패스 7992"
        ></path>
      </g>
    </svg>
  )
}

export default NewsSliderArrowLeft
